import React, { useState } from "react";
import AllDocuments from "./AllDocuments";

const SellerFarmerDocumentVault = () => {
  const [activeTab, setActiveTab] = useState("All Documents");
  const tabs = [
    "All Documents",
    "KYC Document",
    "Trade Contracts / POs",
    "LC / SBLC Documents",
    "Invoices",
    "Shipping / Customs Docs",
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "All Documents":
        return <AllDocuments mode="" />;
      case "KYC Document":
        return <AllDocuments mode="KYC Document" />;
      case "Trade Contracts / POs":
        return <AllDocuments mode="Trade Contracts/POs" />;
      case "LC / SBLC Documents":
        return <AllDocuments mode="LC/SBLC Document" />;
      case "Invoices":
        return <AllDocuments mode="Invoices" />;
      case "Shipping / Customs Docs":
        return <AllDocuments mode="Shipping/Customs Docs" />;
      default:
        return <AllDocuments mode="" />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SellerFarmerDocumentVault;
